import React, { useState } from "react";
import "./App.css";
import Study from "./study";
import logo from "./logo.jpeg";

function Imucor() {
  const [siteCode, setsiteCode] = useState(null);
  const [formMode, setformMode] = useState(true);
  const studyHospital = [
    {
      label: "Site list",
      value: "none",
    },
    {
      label: "JIPMER, Puducherry",
      value: "01",
    },
    {
      label: "Mandya Institute of Medical Sciences, Mandya",
      value: "02",
    },
    {
      label: "KMC, Manipal",
      value: "03",
    },
    {
      label: "Tirunelveli Medical College",
      value: "04",
    },
    {
      label: "AIIMS Jodhpur",
      value: "05",
    },
    {
      label: "AIIMS Patna",
      value: "06",
    },
    {
      label: "Govt. Medical College, Madurai",
      value: "07",
    },
    {
      label: "SIMS, Chennai",
      value: "08",
    },
    {
      label: "Manipal Hospital",
      value: "09",
    },
    {
      label: "LTMMC, Mumbai",
      value: "10",
    },
    {
      label: "PSG, Coimbatore",
      value: "11",
    },
    {
      label: "GKNM, Coimbatore",
      value: "12",
    },
    {
      label: "SRMC, Porur",
      value: "13",
    },
    {
      label: "AIIMS Bathinda",
      value: "14",
    },
    {
      label: "AIIMS Nagpur",
      value: "15",
    },
    {
      label: "J N Medical College, Belagavi",
      value: "16",
    },
    {
      label: "SMIMER, Surat",
      value: "17",
    },
    {
      label: "Gandhi Medical College, Bhopal",
      value: "18",
    },
    {
      label: "RDGMC, Ujjain",
      value: "19",
    },
    {
      label: "Sundaram Medical Foundation Hospital",
      value: "20",
    },
  ];

  const onSubmit = (e) => {
    e.preventDefault();
    setformMode(false);
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-around",
        alignItems: "flex-end",
      }}
    >
      {formMode ? (
        <React.Fragment>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              flexWrap: "wrap",
              alignContent: "center",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <form onSubmit={onSubmit}>
              <label style={{ fontWeight: "bold" }}>
                Select a site to continue
                <select
                  value={siteCode}
                  onChange={(e) => setsiteCode(e.target.value)}
                  className="form-select"
                >
                  {studyHospital.map((hosp, index) => {
                    return <option value={hosp.value}>{hosp.label}</option>;
                  })}
                </select>
              </label>
              <input
                type="submit"
                value="Submit"
                className="btn btn-primary"
                disabled={siteCode === null || siteCode === "none"}
                style={{ marginLeft: "1rem" }}
              />
            </form>

            <div
              className="alert alert-primary"
              role="alert"
              style={{
                marginTop: "5rem",
                lineHeight: 1.8,
              }}
            >
              <h4 className="alert-heading">Instructions</h4>
              <hr />
              <p>
                This portal is for random selection of controls for the I-MUCOR
                study.
              </p>
              <p>Kindly upload the excel in the format given.</p>
              <p>
                The data you submit will not be stored and shall not be
                accessible to NIE.
              </p>

              <p>Kindly save the output file for your future reference</p>
            </div>
          </div>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Study siteCode={siteCode} />
        </React.Fragment>
      )}
    </div>
  );
}

export default Imucor;
